module.exports = __webpack_public_path__ + "img/icon-slide-prev.2ccbb74e.svg";